import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { ESPECIALIDADE_LABEL, type EspecialidadeProf } from "../../types";
import { listarProfissionais } from "../queries";
import { ESPECIALIDADES_ORDEM } from "../types";
import { EspecialidadeBadge } from "../ui/EspecialidadeBadge";

/** Equipe — a "biblioteca" do Elo: profissionais vinculados, filtrável por disciplina. */
export function Equipe() {
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const filtro = params.get("esp") as EspecialidadeProf | null;
  const setFiltro = (e: EspecialidadeProf | null) =>
    setParams(e ? { esp: e } : {}, { replace: true });

  const profissionais = useLiveQuery(() => listarProfissionais()) ?? [];
  const lista = filtro ? profissionais.filter((p) => p.especialidade === filtro) : profissionais;

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>
      <div className="row-entre">
        <h1 className="tela-titulo">equipe</h1>
        <Link to="/elo/equipe/novo" className="btn btn-primario">➕ novo</Link>
      </div>

      <div className="chips" style={{ marginBottom: "var(--s4)" }}>
        <button
          className="chip"
          style={!filtro ? { background: "var(--accent-suave-bg)", color: "var(--accent-forte)", borderColor: "var(--accent-suave-borda)" } : undefined}
          onClick={() => setFiltro(null)}
        >
          todas
        </button>
        {ESPECIALIDADES_ORDEM.map((e) => (
          <button
            key={e}
            className="chip"
            style={filtro === e ? { background: "var(--accent-suave-bg)", color: "var(--accent-forte)", borderColor: "var(--accent-suave-borda)" } : undefined}
            onClick={() => setFiltro(e)}
          >
            {ESPECIALIDADE_LABEL[e]}
          </button>
        ))}
      </div>

      {lista.length === 0 ? (
        <div className="vazio">
          <span className="emoji" aria-hidden>🔗</span>
          {profissionais.length === 0
            ? "nenhum profissional ainda. cadastre o primeiro."
            : "ninguém nesta disciplina."}
        </div>
      ) : (
        <div className="lista-cards">
        {lista.map((p) => (
          <button
            className="card linha-alimento"
            key={p.id}
            onClick={() => nav(`/elo/profissional/${p.id}`)}
          >
            <div className="foto" aria-hidden>👤</div>
            <div className="crescer">
              <div className="row-entre">
                <div className="nome">{p.nome}</div>
                <EspecialidadeBadge especialidade={p.especialidade} curto />
              </div>
              {p.registro_classe && <div className="meta">{p.registro_classe}</div>}
            </div>
          </button>
        ))}
        </div>
      )}
    </main>
  );
}
